export enum ApplicationRole {
  ADMINISTRATOR = "Administrator",
  ELUS_WRITE_ALL = "Elus.Write.All",
  GESTIONNAIRE_ELECTIONS = "Elus.Write.DelegueAG",
  ETABLISSEMENT_PUBLIC_WRITE_ALL = "EtablissementPublic.Write.All",
  INFOS_RUC_WRITE_ALL = "InfosRuc.Write.All",
  REPORTS_READ_ALL = "Reports.Read.All",
  COMMENTAIRES_WRITE = "Commentaires.Write.All",
}
